<template>
  <div>

    <div class="d-flex align-end justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          ติดตามความก้าวหน้า
        </div>
        <div class="d-flex align-center">
          <Iconify
              icon="ion:document-text"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          <div class="font-type-bold txt-head black--text">รายงานผลการดำเนินการ</div>
        </div>
      </div>

      <Button
          theme="7"
      >
        Export Excel
      </Button>
    </div>

    <div class="d-flex gap-24 mb-5">
      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">โครงการหลัก</div>
        <AutoBox
            placeholder="โครงการหลัก"
            hide-details
            :items="masterData.main_project_list"
            :value="masterData.main_project_id"
            item-text="name"
            item-value="id"
            clearable
            @onChange="masterData.main_project_id = $event; getProgress()"
        ></AutoBox>
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">ภูมิภาค</div>
        <SelectBox
            placeholder="ภูมิภาค"
            hide-details
            style="max-width: 160px"
            :items="masterData.region_masters"
            :value="parseInt(masterData.region_id)"
            item-text="name"
            item-value="id"
            clearable
            @onChange="masterData.region_id = $event; getProgress()"
        ></SelectBox>
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">แผนงาน</div>
        <AutoBox
            placeholder="แผนงาน"
            hide-details
            :items="masterData.plan_masters"
            :value="masterData.plan_master_id"
            item-text="plan_name_th"
            item-value="id"
            clearable
            @onChange="masterData.plan_master_id = $event; getProgress()"
        ></AutoBox>
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">ปี งปม.</div>
        <SelectBox
            placeholder="ปี งปม."
            hide-details
            :items="yearList"
            :value="masterData.fiscal_year"
            item-text="plan_name_th"
            item-value="id"
            style="max-width: 160px"
            @onChange="masterData.fiscal_year = $event;getProgress()"
        ></SelectBox>
      </div>
    </div>

<!--    <divcard class="d-flex flex-column gap-8 mb-5">-->
<!--      <div class="d-flex gap-8">-->
<!--        <div class="black&#45;&#45;text font-type-bold" style="min-width: 140px; max-width: 140px">แผนงาน</div>-->
<!--        <div>-->
<!--          {{ masterData.plan_name }}-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="d-flex gap-8">-->
<!--        <div class="black&#45;&#45;text font-type-bold" style="min-width: 140px; max-width: 140px">ปี งปม.</div>-->
<!--        <div>-->
<!--          {{ masterData.fiscal_year }}-->
<!--        </div>-->
<!--      </div>-->
<!--    </divcard>-->

    <divcard
        v-for="(region, i) in regions"
        :key="i"
        class="d-flex flex-column gap-8 mb-5"
    >
      <div class="black--text font-type-bold">
        {{ region.name }}
      </div>

      <div class="py-5 overflow-x-auto mx-n6 px-6 hide-scroll">
        <div class="d-flex justify-space-between align-center gap-8 px-3 mb-3">
          <div class="flex" style="min-width: 30px; max-width: 30px">
          </div>
          <div class="flex" style="min-width: 120px; max-width: 120px">
            โครงการ
          </div>
          <div class="flex text-center" style="min-width: 61px; max-width: 61px">
            WF
          </div>
          <div
              v-for="(m, ind) in region.yearMonthList"
              :key="ind"
              class="flex"
              style="min-width: 43px; max-width: 43px"
          >
            <div class="text-center">{{ m.month_th }}</div>
            <div class="text-center">{{ m.year_th }}</div>
          </div>
          <div class="flex" style="min-width: 43px; max-width: 43px">
            แผนผล
          </div>
          <div class="flex text-center" style="min-width: 43px; max-width: 43px">
            %
          </div>
        </div>

        <!--   PLAN ITEMS   -->
        <div v-if="region.form_c_list && region.form_c_list.length > 0" class="d-flex flex-column gap-12">
          <div
              v-for="(item, c_i) in region.form_c_list"
              :key="c_i"
              class="plan-card d-flex justify-space-between gap-8"
          >
            <div class="flex" style="min-width: 30px; max-width: 30px"></div>
            <div class="flex two-line" style="min-width: 120px; max-width: 120px; max-height: 45px">
              {{ item.project_section_general_info.project_name_th }}
            </div>
            <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px; height: 54px">
              <v-divider vertical></v-divider>
              <div class="tiny-field tf-active" style="min-width: 40px; max-width: 40px; height: 100%">
                {{ formatNumber(item.wf, 2) }}
              </div>
              <v-divider vertical></v-divider>
            </div>
            <div
                v-for="(m, m_i) in item.project_section_plan_p1_budget"
                :key="m_i"
                class="flex d-flex flex-column gap-8"
                style="min-width: 43px; max-width: 43px"
            >
              <div class="tiny-field">
                {{ m.month_value ? formatNumber(m.month_value, 2) : '-' }}
              </div>
              <div class="tiny-field">
                {{ m.actual_month_value ? formatNumber(m.actual_month_value, 2) : '-' }}
              </div>
            </div>

            <div class="flex d-flex flex-column gap-8" style="min-width: 43px; max-width: 43px">
              <div class="tiny-field">
                {{ formatNumber(item.plan, 2) }}
              </div>
              <div class="tiny-field">
                {{ formatNumber(item.result, 2) }}
              </div>
            </div>

            <div class="flex d-flex flex-column gap-8" style="min-width: 43px; max-width: 43px">
              <div class="tiny-field">
                {{ formatNumber(item.percent, 2) }}
              </div>
              <div class="tiny-field">
                {{ formatNumber(parseFloat((item.result * 100) / item.plan), 2) }}
              </div>
            </div>
          </div>

          <!--   SUMMARY   -->
          <div class="plan-card">
            <div class="d-flex justify-space-between gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px">

              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                แผนงานถ่วงน้ำหนัก
              </div>
              <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                <v-divider vertical></v-divider>
                <div class="tiny-field" :class="{ 'theme-color-four tf-error': totalWF(region.form_c_list) !== '1.00' }" style="min-width: 40px; max-width: 40px">
                  {{ totalWF(region.form_c_list) }}
                </div>
                <v-divider vertical></v-divider>
              </div>

              <div
                  v-for="(m, ym_i) in region.yearMonthList"
                  :key="ym_i"
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
              >
                {{ weightPlan(region.form_c_list, ym_i) }}
              </div>

              <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                {{ weightActivePlan(region.form_c_list) }}
              </div>
              <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                {{ weightActivePlanPercent(region.form_c_list) }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex justify-space-between gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px">

              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                ผลการดำเนินงาน
              </div>
              <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px">
                </div>
                <v-divider vertical></v-divider>
              </div>
              <div
                  v-for="(m, ym_ind) in region.yearMonthList"
                  :key="ym_ind"
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
              >
                {{ resultPlan(region.form_c_list, ym_ind) }}
              </div>
              <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                {{ weightActiveResult(region.form_c_list) }}
              </div>
              <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                {{ formatNumber(parseFloat((weightActiveResult(region.form_c_list) * 100) / weightActivePlan(region.form_c_list)), 2) }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex justify-space-between gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px">

              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                การใช้จ่ายจริง
              </div>
              <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px">
                </div>
                <v-divider vertical></v-divider>
              </div>
              <div
                  v-for="(m, ym_index) in region.yearMonthList"
                  :key="ym_index"
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
              >
                {{ m.rateBudget }}
              </div>
              <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                1.00
              </div>
              <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                1.00
              </div>
            </div>

          </div>
        </div>

        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>

      </div>
    </divcard>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import SelectBox from "../../components/input/SelectBox"
import { mapState } from "vuex"
import AutoBox from "@/components/input/AutoBox"
import Button from "@/components/input/Button"
import { formatNumber } from "@/plugins/global-funcs"
import { format } from "date-fns"
import { th } from "date-fns/locale"

export default {
  name: "ProgressFollowed",
  components: {
    TextField,
    SelectBox,
    AutoBox,
    Button
  },
  data () {
    return {
      formatNumber,
      masterData: {},
      regions: [],
      yearBudgetList: [],
      yearList: []
    }
  },
  created () {
    this.generateYearList()
    this.getProgress()
  },
  computed: {
    ...mapState({
      isUSP: state => state.Auth.User.user_type === 'USP',
      isRSP: state => state.Auth.User.user_type === 'RSP'
    })
  },
  methods: {
    async getProgress () {
      let payload = {
        main_project_id: this.masterData.main_project_id,
        plan_master_id: this.masterData.plan_master_id,
        region_id: this.masterData.region_id,
        fiscal_year: this.masterData.fiscal_year
      }
      console.log('payload1', payload)
      let res
      res = await this.$apiFire('MonthlyProgress/getProgressRSP', payload)
      console.log(res)

      let ind = 0
      for (const x of res.regions) {
        for (const c of x.form_c_list) {
          c.percent = this.getLastProgress(c.project_section_plan_p1_budget)
          let i = 0
          for (const y of c.project_section_plan_p1_budget) {
            let correctIndex = this.isInCorrectRange(y, i)
            if (typeof correctIndex !== 'boolean') {
              x.plan = res.regions[ind].project_section_plan_p1_budget[correctIndex].month_value
              x.result = res.regions[ind].project_section_plan_p1_budget[correctIndex].actual_month_value
            }
            i++
          }
        }

        x.yearMonthList = x.yearMonthList.map(ym => ({
          month_th: format(new Date(ym), 'MMM', { locale: th }), // to TH short month
          year_th: (parseInt(ym.toString().split('-')[0]) + 543).toString().slice(2) // last 2 letters of year string
        }))

        ind++
      }

      this.masterData = { ...res, regions: undefined }
      this.regions = res.regions
    },
    totalWF (plans) {
      if (!plans || plans.length === 0) return '-'
      let total = plans.map(x => x.wf).reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      if (typeof total === 'number') return total.toFixed(2)
      return total
    },
    weightPlan (plans, index) {
      let total = []
      for (const x of plans) {
        let result = x.project_section_plan_p1_budget[index] ? parseFloat(x.project_section_plan_p1_budget[index].month_value * x.wf) : 0
        if (!isNaN(result)) {
          total.push(result)
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0)
      } else {
        total = '-'
      }
      if (typeof total === 'number') return total.toFixed(2)
      return total
    },
    weightActivePlan (plans) {
      let ind = 0
      for (const x of plans) {
        let i = 0
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i)
          if (typeof correctIndex !== 'boolean') return this.weightPlan(plans, correctIndex)
          i++
        }
        ind++
      }
    },
    weightActivePlanPercent (plans) {
      let all = []
      for (let i = 0; i < plans.length; i++) {
        all.push(this.weightPlan(plans, i))
      }

      if (all.length > 0) {
        for (const x of all.reverse()) {
          if (!!x && x !== '-') {
            return x
          }
        }
      }
      return '-'
    },
    weightActiveResult(plans) {
      let ind = 0
      for (const x of plans) {
        let i = 0
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i)
          if (typeof correctIndex !== 'boolean') return this.resultPlan(plans, correctIndex)
          i++
        }
        ind++
      }
    },
    resultPlan(plans, index) {
      let total = []
      for (const x of plans) {
        let result = parseFloat(x.project_section_plan_p1_budget[index].actual_month_value * x.wf)
        if (!isNaN(result)) {
          total.push(result)
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0)
      } else {
        total = '-'
      }
      if (typeof total === 'number') return total.toFixed(2)
      return total
    },
    getLastProgress (items) {
      items = this.removeVModel(items)
      if (items && typeof items === 'object' && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== '-') {
            return x.month_value
          }
        }
      }
      return '-'
    },
    removeVModel (item) {
      return JSON.parse(JSON.stringify(item))
    },
    isInCorrectRange (item, index = null) {
      let today = new Date()
      let currentMonth = today.getMonth()
      let thisMonth = new Date(item.yearMonth).getMonth()
      let isCorrectCase = (today.getDate() >= 5 && thisMonth === currentMonth) || (today.getDate() <= 4 && thisMonth === (currentMonth - 1))

      // for return active yearMonth index
      if (isCorrectCase && (index !== null)) return index
      return isCorrectCase
    }, generateYearList() {
      var currentYear = new Date().getFullYear();
      var yearList = [];

      for (var year = currentYear; year >= currentYear - 20; year--) {
        yearList.push(year + 543);
      }

      this.yearList = yearList;
    }
  }
}
</script>

<style scoped lang="scss">
.plan-card {
  background: #FFFFFF;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}
</style>